(function () {
  class Carousel {
    constructor(el) {
      if (!el) return;
      this.element = el;
      this.element.classList.add("sk-carousel");
      this.scroller = el.querySelector(".sk-carousel-scroller");
      this.left = el.querySelector(".sk-carousel-left");
      this.right = el.querySelector(".sk-carousel-right");
      const update = () => {
        const { scrollWidth, clientWidth, scrollLeft } = this.scroller;
        const hasOverflow = scrollWidth > clientWidth;
        const scrollStart = Math.abs(scrollLeft) < 2;
        const scrollEnd =
          Math.abs(scrollLeft - (scrollWidth - clientWidth)) < 2;
        this.element.classList.toggle("has-overflow", hasOverflow);
        this.element.classList.toggle("scroll-start", scrollStart);
        this.element.classList.toggle("scroll-end", scrollEnd);
      };
      this.scroller.addEventListener("scroll", throttle(update, 100));
      update();
      const goto = (offset) => {
        if (offset !== -1 && offset !== 1) return;
        const { scrollWidth, clientWidth, scrollLeft } = this.scroller;
        const items = this.scroller.querySelectorAll(".sk-carousel-item");
        const [item] = items;
        const itemWidth = scrollWidth / items.length;

        const marginalItemPosition =
          offset > 0
            ? (scrollLeft + clientWidth - itemWidth / 2) / itemWidth
            : (scrollLeft + itemWidth / 2) / itemWidth;
        const marginalItemIndex = Math.floor(marginalItemPosition);
        const nextIndex = Math.min(
          Math.max(0, marginalItemIndex + offset),
          items.length - 1
        );

        this.scroller.scroll({
          left: offset > 0 ? itemWidth * (nextIndex + 1) - clientWidth : itemWidth * nextIndex, 
          behavior: "smooth",
        });
      };
      this.left.addEventListener("click", () => {
        goto(-1);
      });
      this.right.addEventListener("click", () => {
        goto(1);
      });
    }
  }

  window.Carousel = Carousel;
})();
